import React, { FC, useEffect, useState } from 'react';
import { Button, Form, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import PhoneInput from '~/components/PhoneInput';
import { SendMoneyState } from '~/types';
import styled from 'styled-components';

interface InputPhoneProps {
  mainState: SendMoneyState;
  setMainState: React.Dispatch<React.SetStateAction<SendMoneyState>>;
  onNext: (recipientPhoneNumber: string) => void;
  isLoading: boolean;
}

const SubmitButton = styled(Button)`
  margin-top: 16px;
`;

const InputPhone: FC<InputPhoneProps> = ({ mainState, setMainState, onNext, isLoading }) => {
  const { recipientPhoneNumber } = mainState;
  const { t } = useTranslation('sendMoney');

  const [form] = Form.useForm();
  const [isPhoneValid, setIsPhoneValid] = useState(false);

  useEffect(() => {
    const phoneNumberObj = parsePhoneNumberFromString(recipientPhoneNumber || '');
    setIsPhoneValid(phoneNumberObj?.isValid() || false);
  }, [recipientPhoneNumber]);

  const handleFinish = ({ recipientPhoneNumber }: { recipientPhoneNumber: string }) => {
    onNext(recipientPhoneNumber);
  };

  return (
    <div>
      <Typography.Title level={4} style={{ fontWeight: 500 }}>
        {t('recipientPhoneNumber')}
      </Typography.Title>
      <Form
        layout="vertical"
        form={form}
        name="inputPhoneForm"
        onFinish={handleFinish}
        onValuesChange={(_, values) => setMainState((prev) => ({ ...prev, ...values }))}
        initialValues={{ recipientPhoneNumber: mainState?.recipientPhoneNumber }}
      >
        <Form.Item
          name="recipientPhoneNumber"
          rules={[
            {
              validator: (_, value) => {
                const phoneNumberObj = parsePhoneNumberFromString(value || '');
                if (phoneNumberObj?.isValid()) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error(t('inputPhoneNumber')));
              },
            },
          ]}
        >
          <PhoneInput />
        </Form.Item>
        <SubmitButton
          type="primary"
          block
          disabled={!isPhoneValid}
          htmlType="submit"
          loading={isLoading}
        >
          {isPhoneValid ? t('continue') : t('inputPhoneNumber')}
        </SubmitButton>
      </Form>
    </div>
  );
};

export default InputPhone;
